import { useCurrentDoc } from 'docz';
import { useMemo } from 'react';

function usePrevNext(menus) {
  var currentDoc = useCurrentDoc();
  return useMemo(function () {
    // if no menus
    if (!menus) return {}; // init vars

    var found = false;
    var prev = null;
    var next = null; // check menu item helper

    var checkItem = function checkItem(item, path) {
      // if item was already found just add next and exit
      if (found) {
        next = {
          path: path,
          item: item
        };
        return true;
      } // if item found then mark and continue to next


      if (item.slug === currentDoc.slug) found = true; // else fill prev item
      else prev = {
          path: path,
          item: item
        }; // continue

      return false;
    }; // loop all groups until found


    Object.keys(menus).some(function (groupKey) {
      var basePath = groupKey.length > 0 ? [groupKey] : []; // loop all menu items in group until found

      return menus[groupKey].some(function (menuItem) {
        // if no sub-menus
        if (!menuItem.menu) {
          return checkItem(menuItem, basePath);
        }

        var subMenuGroups = menuItem.extendedMenu || {
          name: '',
          menu: menuItem.menu
        }; // check all sub-menu groups

        return subMenuGroups.some(function (subGroup) {
          // loop sub-menu items
          return subGroup.menu.some(function (subItem) {
            // build path
            var path = [].concat(basePath, [subItem.name]);
            if (subItem.submenu) path.push(subItem.submenu);
            return checkItem(subItem, path);
          });
        });
      });
    });
    return {
      prev: prev,
      next: next
    };
  }, [currentDoc.slug, menus]);
}

export default usePrevNext;

if (typeof usePrevNext !== 'undefined' && usePrevNext && usePrevNext === Object(usePrevNext) && Object.isExtensible(usePrevNext) && !usePrevNext.hasOwnProperty('__filemeta')) {
  Object.defineProperty(usePrevNext, '__filemeta', {
    configurable: true,
    value: {
      name: "usePrevNext",
      filename: "node_modules/gatsby-theme-docz-oh/src/gatsby-theme-docz/hooks/usePrevNext.js"
    }
  });
}